module.exports = __webpack_public_path__ + "img/EDSB_80X30.c804e7ad.png";